import { t } from 'utils/localize';
import useLoaderPromise from './useLoaderPromise';
import useToastPromise from './useToastPromise';

export default function useToastLoaderPromise<T, Args extends any[]>(
  request: (...args: Args) => Promise<T>,
  loaderText: string = t('Loading...'),
  errorText: string = t('Something went wrong...')
) {
  return useLoaderPromise(useToastPromise(request, errorText), loaderText);
}
